import styled from 'styled-components';
import { StyledProps } from '@/components/Campaigns/CampaignsInterface';

export const SearchInputWrapper = styled.div`
    width: 280px;
`;

export const TableFiltersWrapper = styled.div<StyledProps>`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: ${({ isMobile }): string => !isMobile && '25px 48px 34px'};
    margin: ${({ isMobile }): string => isMobile && '32px 0 20px 0'};
`;

export const FiltersWrapper = styled.div`
    display: flex;
    .popoverWrapperDateDropdown {
        margin-right: 16px;
    }
`;